// src/components/Header.js
import React, { useState } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom'; // Use NavLink for active states
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaTwitter, FaPinterestP, FaInstagram, FaWhatsapp } from 'react-icons/fa';
// import WebbloomLogo from '../assets/logo/logo.png';
import { FiSearch } from 'react-icons/fi';
import { Fade } from 'react-awesome-reveal';

const Header = () => {
  const { pathname } = useLocation();
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = (to) => {
    if (pathname === to) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    setExpanded(false);
  };

  return (
    <Fade triggerOnce direction="down" duration={800}>
      {/* Top Bar */}
      <div className="bg-dark text-white-50 small py-2 d-none d-lg-block border-bottom border-secondary">
        <Container className="d-flex justify-content-between align-items-center">
          <div className="d-flex">
            <span className="me-3 text-white"><FaEnvelope className="me-1" />  vishal@webbloom.in</span>
            <span className="me-3 text-white"><FaMapMarkerAlt className="me-1" /> Andheri East, Mumbai, Maharashtra</span>
          </div>
          <div className="d-flex align-items-center">
            {/* <span className="me-3">Help / Support / Contact</span> */}
            <div className="d-flex social-icon-top-header">
              <a href="https://www.facebook.com/share/1CV2WaVUdG/" className="text-white-50 ms-2"><FaFacebookF /></a> 
              <a href="https://www.instagram.com/webbloomindia?igsh=Z25wMTc3bG1zZnlq" className="text-white-50 ms-2"><FaInstagram /></a>
            </div>
          </div>
        </Container>
      </div>

      {/* Main Navbar */}
      <Navbar bg="dark" variant="dark" expand="lg" sticky="top" className="top-header" expanded={expanded} onToggle={(value) => setExpanded(value)}>
        <Container>
          <Navbar.Brand as={NavLink} to="/" onClick={() => setExpanded(false)}>
           <img src="/assets/logo/logo.png" alt="Webbloom Logo" className="img-fluid logo" />
          </Navbar.Brand> {/* Link brand to home */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto me-auto"> {/* Centered for larger screens, auto for mobile */}
              <Nav.Link as={NavLink} to="/" end onClick={() => handleNavClick('/')}>Home</Nav.Link> {/* Use 'end' for exact match */}
              <Nav.Link as={NavLink} to="/about-us" onClick={() => handleNavClick('/about-us')}>About Us</Nav.Link>
              <Nav.Link as={NavLink} to="/services" onClick={() => handleNavClick('/services')}>Services</Nav.Link>
              <Nav.Link as={NavLink} to="/contact-us" onClick={() => handleNavClick('/contact-us')}>Contact Us</Nav.Link>
            </Nav>
            <Nav className="d-none d-md-block d-flex align-items-center"> 
              <Button
                  as="a"
                  href="https://wa.me/916388414242"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="primary"
                  className="d-flex align-items-center rounded-pill px-4 py-2"
                >
                  <FaWhatsapp className="me-2" />
                  WhatsApp Now
                </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Fade>
  );
}

export default Header;